module.exports = __webpack_public_path__ + "static/img/1.0abe19d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/1.png
// module id = F2LY
// module chunks = 0